import { Component, OnInit } from '@angular/core';
import { QueryParameters } from '../../../reporting/analytics-core/interfaces/query-parameters.interface';
import { StorageSessionService } from '../../storage/services/storage.session.service';
import { LoginService } from '../services/login.service';
import { Router } from '@angular/router';
import { AnalyticsCoreURLService } from '../../../reporting/analytics-core/services/analytics-core.url.service';
import * as jQuery from 'jquery';

@Component({
	selector: 'app-login',
	templateUrl: '../views/login.component.html',
	styleUrls: ['../styles/login.component.css']
})
export class LoginComponent implements OnInit {
	public username = '';
	public password = '';
	public errorMessage = '';
	showLoginLoader = true;
	public showPasswordResetForm = false;
	public resetPasswordMessage = '';
	public isSSOEnabled = null;
	public usernameTip = '';
	public showSSOUserEmailSection = true;

	constructor(
		private loginService: LoginService,
		private router: Router,
		private storageSessionService: StorageSessionService,
		private analyticsCoreURLService: AnalyticsCoreURLService
	) {
		this.showLoginLoader = false;
	}

	ngOnInit() {
		this.showLoginLoader = true;
		this.isSSOEnabledFlow();
	}

	login() {
		this.showLoginLoader = true;
		if (this.username === '' || this.password === '') {
			this.showLoginLoader = false;
			this.errorMessage = 'Please fill in your details.';
		}
		if (this.username !== '' && this.password !== '') {
			this.loginService.getPartnerCname({ username: this.username, pwd: this.password }).subscribe((response: any) => {
				if (response.success) {
					const queryParamsObj = this.storageSessionService.getQueryParamsObj();
					/* Set the ServiceURL to the Partner CNAME domain here - so that login 
					and all subsequent API calls uses the Partner CNAME domain */
					this.analyticsCoreURLService.updateServiceURLForPartnerCNAME(response.partner_domain);
					this.loginService.login({ username: this.username, pwd: this.password }).subscribe((response: any) => {
						if (response.success) {
							const queryParamsObj = this.storageSessionService.getQueryParamsObj();
							this.router.navigate([this.storageSessionService.URLproductRoute], { queryParams: queryParamsObj });
						} else {
							this.showLoginLoader = false;
							if (response.reset_password) {
								this.showPasswordReset();
							} else {
								this.errorMessage = 'Invalid Credentials';
							}
						}
					});
				} else {
					this.showLoginLoader = false;
					if (response.reset_password) {
						this.showPasswordReset();
					} else {
						this.errorMessage = 'Invalid Credentials';
					}
				}
			});
		}
	}

	showPasswordReset() {
		this.showPasswordResetForm = true;
		jQuery('.card').toggleClass('flipped');
	}

	hidePasswordReset() {
		this.showPasswordResetForm = false;
		jQuery('.card').toggleClass('flipped');
	}

	resetPassword() {
		if (this.username === '') {
		} else {
			const emailModel = { email: this.username };
			this.loginService.resetPassword(emailModel).subscribe((response: any) => {
				this.resetPasswordMessage = response.message;
				this.hidePasswordReset();
			});
		}
	}

	isSSOEnabledFlow() {
		var hostnameurl = this.loginService.getHostname();
		var queryParamsObj = this.storageSessionService.getQueryParamsObj();
		var relayState = window.location.protocol + '//' + hostnameurl;
		var relayStateProduct = this.storageSessionService.URLproductRoute;
		this.loginService
			.isSSOEnabledFlow({
				hostname: hostnameurl,
				queryparams: queryParamsObj,
				relayStateProduct: relayStateProduct,
				relayState: relayState
			})
			.subscribe((response: any) => {
				if (response.is_sso_flow) {
					if (response.loggedIn) {
						window.location.href = response.redirect_url;
					} else {
						this.isSSOEnabled = 'true';
						this.usernameTip = response.username_helper_tip;
					}
				} else {
					this.isSSOEnabled = 'false';
				}
				this.showLoginLoader = false;
			});
	}
}
